var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "#9E29F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07492 21.875H18.9229C19.5869 21.875 20.125 21.3369 20.125 20.6729V14.1772C20.125 13.5132 19.5869 12.9751 18.9229 12.9751H18.5094H17.9525H17.3432H16.632H11.3589V10.5171C11.3589 8.85467 12.6764 7.44318 14.3388 7.4364C15.1698 7.43313 15.9221 7.76819 16.4668 8.31285C17.0088 8.8527 17.3432 9.60019 17.3432 10.4264V11.2569C17.3432 11.6191 17.6368 11.9126 17.9989 11.9126C18.3611 11.9126 18.6546 11.6191 18.6546 11.2569V10.5348C18.6546 8.20575 16.8484 6.21856 14.5211 6.1283C12.0728 6.03344 10.0475 7.99855 10.0475 10.4266V12.9751H9.07711C8.41311 12.9751 7.875 13.5132 7.875 14.1772V20.6751C7.875 21.3378 8.41223 21.875 9.07492 21.875ZM14.5325 14.905C15.2669 14.9837 15.8767 15.5694 15.9794 16.3038C16.0712 16.9639 15.7696 17.5649 15.2734 17.9015C15.1401 17.9933 15.0548 18.1419 15.0548 18.3037V19.3637C15.0548 19.5101 14.9368 19.6282 14.7904 19.6282H13.9118C13.7653 19.6282 13.6473 19.5101 13.6473 19.3637V18.3037C13.6473 18.1419 13.5642 17.9933 13.4309 17.9037C12.9938 17.6064 12.7075 17.1059 12.7075 16.5398C12.7075 15.5714 13.5424 14.8001 14.5325 14.905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/changePassword.9e162f7e052d1695d7d1ad82d27c7b4a.svg";
export { ForwardRef as ReactComponent };